import { createAction, createReducer } from 'deox';

export interface Analytics {
  applicationStarted: boolean;
}

const defaultState: Analytics = {
  applicationStarted: false,
};

export const setAnalyticsState = createAction(
  'SET_ANALYTICS_STATE',
  resolve => (analytics: Partial<Analytics>) => resolve(analytics),
);

export const analyticsReducer = createReducer(defaultState, handleAction => [
  handleAction(setAnalyticsState, (state, { payload }) => ({
    ...state,
    ...payload,
  })),
]);

interface MountedState {
  analytics: Analytics;
}

export const selectAnalytics = (state: MountedState): Analytics => {
  return state.analytics;
};

export default analyticsReducer;
